import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {UserSubscription} from "../../../../user/user-subscription";
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {OneMonthFreeStep} from "../one-month-free/one-month-free.component";
import {Router} from "@angular/router";
import {User} from "../../../../user/user";
import {GoogleAnalyticsService} from "../../../services/google-analytics/google-analytics.service";
import {Utils} from "../../../../shared/utils/utils";


@Component({
    selector: 'db-domain-offer',
    templateUrl: './domain-offer.component.html',
    styleUrls: ['./domain-offer.component.scss'],
    standalone: false
})
export class DomainOfferComponent implements OnInit {

  @Input() single: boolean = false;
  @Input() user: User;
  @Input() title: string;
  @Input() desc: string;
  @Input() buttonText: string;
  @Input() currentSubscription: UserSubscription;
  @Output() onStepChange? = new EventEmitter<OneMonthFreeStep>();
  public isMobile: boolean;
  public demoUser: boolean;

  constructor(
    private readonly activeModal: DbActiveModal,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this.demoUser = Utils.isDemoUser(this.currentSubscription, this.user);
    if (!localStorage.getItem('domainOfferSeen' + this.user?.id)) {
      localStorage.setItem('domainOfferSeen' + this.user?.id, '1');
    }
    this.activeModal.whiteCloseBtn(true, 0.5);
    this.isMobile = window.innerWidth <= 991;
  }

  public getDomain(): void {
    let analyticsData;
    if (!this.currentSubscription?.trialClient) {
      analyticsData = {
        eventCategory: 'Dashboard Action',
        eventAction: "Connect your domain",
        eventLabel: 'Connect your domain: Domains announcement popup'
      };
    }
    else {
      analyticsData = {
        eventCategory: (this.demoUser ? 'Free Upgrade Offer' : 'Free trial paywalls'),
        eventAction: "Locked button click",
        eventLabel: 'Connect your domain: Domains announcement popup'
      };
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this._router.navigate(['/domains-handler/search'])
    this.activeModal.close();

  }

}

